// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + (chunkId === 443 ? "about" : chunkId) + "." + {"52":"2c42ed4a","83":"9ec74f4e","104":"17576acf","443":"50dc711b","563":"65c82425","610":"c2893925","672":"8ad2a49c","766":"cba5001f"}[chunkId] + ".js";
};